import axios from "axios";
import { redirectToLogin, TOKEN_REFRESHED_EVENT } from "../login";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_CORE_API}/api`,
});

instance.interceptors.request.use(async function (config) {
  const loggedInToken = localStorage.getItem("authorization");
  config["headers"]["Authorization"] = `Bearer ${loggedInToken}`;

  return config;
});

// Expired/invalid token -> clear session and send the user to login.
// Active sessions: the backend sends a renewed token once the current one is
// past half its lifetime; store it and let App.js re-arm its logout timer.
instance.interceptors.response.use(
  (response) => {
    const renewed = response.headers?.["x-refresh-token"];
    if (renewed && localStorage.getItem("authorization")) {
      localStorage.setItem("authorization", renewed);
      window.dispatchEvent(new Event(TOKEN_REFRESHED_EVENT));
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);

export default instance;
